import React, { createContext, useState, useCallback } from 'react'
import { googleLogout } from '@react-oauth/google'
import jwt_decode from 'jwt-decode'

const GoogleAuthContext = createContext()

const tokenName = 'clippingsToken'

function isUserSignedIn () {
  const token = localStorage.getItem(tokenName)
  if (token) {
    const decoded = jwt_decode(token)
    const isTokenValid = true
    return decoded.exp > Date.now() / 1000 && isTokenValid
  }
  return false
}

export const AuthProvider = ({ children }) => {
  const [isSignedIn, setIsSignedIn] = useState(isUserSignedIn())

  const handleSignInFailure = useCallback((error) => {
    console.error('Google sign-in failed:', error)
    console.error('Current origin:', window.location.origin)
  }, [])

  const handleSignInSuccess = useCallback((credentialResponse) => {
    const tokenId = credentialResponse.credential
    if (!tokenId) {
      handleSignInFailure({ error: 'missing credential' })
      return
    }
    localStorage.setItem(tokenName, tokenId)
    const decoded = jwt_decode(tokenId)
    localStorage.setItem('profilePic', decoded.picture)
    localStorage.setItem('name', decoded.given_name)
    setIsSignedIn(true)
  }, [handleSignInFailure])

  const signOut = useCallback(() => {
    googleLogout()
    localStorage.removeItem(tokenName)
    localStorage.removeItem('profilePic')
    localStorage.removeItem('name')
    setIsSignedIn(false)
  }, [])

  return (
    <GoogleAuthContext.Provider value={{ handleSignInSuccess, handleSignInFailure, signOut, isSignedIn }}>
      {children}
    </GoogleAuthContext.Provider>
  )
}

export const useGoogleAuth = () => {
  const context = React.useContext(GoogleAuthContext)
  return context
}
